import { DefaultError, useMutation } from '@tanstack/react-query';
import { useQueryToast } from 'hooks';
import i18next from 'i18next';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { IAuthResponse, ILoginServiceCode } from './types';
import { useStoreState } from 'providers/StoreStateContext';

export const useLoginServiceCode = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast('useLoginServiceCode');
  const { setToken, setRefreshToken, setServiceTokenExpiresAt } = useStoreState();
  return useMutation<IAuthResponse, DefaultError, ILoginServiceCode>({
    async mutationFn(body) {
      loading(i18next.t('service-message.auth.login.loading'));
      const response = await apiClient({
        method: 'POST',
        url: 'Auth/LoginServiceCode',
        body,
      });

      return responseHandler(response, { groupName: 'useLoginServiceCode' });
    },
    onError: dismiss,
    onSuccess: data => {
      success(i18next.t('service-message.auth.login.success'));
      setToken(data.token);
      setRefreshToken(data.refreshToken);
      setServiceTokenExpiresAt(null);
    },
  });
};
